export class PlanoPagamento {
  constructor ({
    id,
    descricao,
    tabela,
    // ativo,
  } = {
    id: '',
    descricao: '',
    tabela: null,
    // ativo: true,
  }) {
    this.id = id
    this.descricao = descricao
    this.tabela = tabela
    // this.ativo = ativo
  }
}

export function createPlanoPagamento (data) {
  return Object.freeze(new PlanoPagamento(data))
}
